import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { ContentProvider } from './lib/content';

import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import LeadsInbox from './pages/admin/LeadsInbox';
import ContentSectionEditor from './pages/admin/ContentSectionEditor';
import SmtpSettings from './pages/admin/SmtpSettings';
import GeneralSettings from './pages/admin/GeneralSettings';
import MediaLibrary from './pages/admin/MediaLibrary';

import './App.css';

export default function App() {
  return (
    <ContentProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<LeadsInbox />} />
              <Route path="content/:section" element={<ContentSectionEditor />} />
              <Route path="settings/smtp" element={<SmtpSettings />} />
              <Route path="settings/general" element={<GeneralSettings />} />
              <Route path="media" element={<MediaLibrary />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ContentProvider>
  );
}
